import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api/rest';
import { AddCardRequest } from '@shared/api/rest/cards';
import { RequestStrategyEnum } from '@shared/api/rest/models';
import { useNotificationStore } from '../misc';
import { Constants } from '@shared/widgets';

interface AddCardsType {
  loading: boolean;
  error: string | null;
  add: (request: AddCardRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAddCardStore = create<AddCardsType>((set) => ({
  loading: false,
  error: null,

  add: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null });
      await CardsApi.addCard(request, signal);
      set({ loading: false });
      useNotificationStore.getState().setSuccess(Constants.DEFAULT_SUCCESS_MESSAGE);
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null }),
}));
